export default __webpack_public_path__ + "static/media/pictures.8d9f61a9.svg";